module.exports = __webpack_public_path__ + "static/media/HeadingNow-95Medium.dc688444.otf";